import { render } from "./OtherSetting.vue?vue&type=template&id=f5f2399c"
import script from "./OtherSetting.vue?vue&type=script&lang=js"
export * from "./OtherSetting.vue?vue&type=script&lang=js"

import "./OtherSetting.vue?vue&type=style&index=0&id=f5f2399c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__